import { combineReducers } from 'redux';

import selectedStatus from './reducers/selected-status';
import duplicateEventModal from './reducers/duplicate-event-modal';
import flashMessages from './reducers/flash-messages';
import search from './reducers/search';

const rootReducer = combineReducers({
  selectedStatus,
  duplicateEventModal,
  flashMessages,
  search
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/my-events/reducer.js